function stopPropagation (e) {
  e.stopPropagation()
}
export default {
  update: function (el, { oldValue, value }) {
    // 开启弹窗，就要实现body fixed的效果
    if (value) {
      const scrollTop = document.body.scrollTop || document.documentElement.scrollTop
      const style = `position:fixed;top:-${scrollTop}px;overflow:hidden;`
      document.body.style = style
      el.addEventListener('scroll', stopPropagation)
    } else if (!value && oldValue) {
      const style = 'position:static;top:auto;overflow:auto;'
      const top = document.body.style.top
      document.body.style = style
      document.body.scrollTop = document.documentElement.scrollTop = Math.abs(Number.parseFloat(top))
      el.removeEventListener('scroll', stopPropagation)
    }
  }
}
